export default "__VITE_ASSET__4bc758e2__"